module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Design/Stamp-47a7ce1bf40edbec494481bad754c7e9.svg";